import type { GridEventListener } from "@mui/x-data-grid";
import { useResourceContext } from "ui/widgets/Resource";
import useLedgerActions from './useLedgerActions';

export default function useLedgerResource() {
    const { onOpen } = useResourceContext();

    const onRowClick: GridEventListener<'rowClick'> = ({ row }) => !row && onOpen(row);

    return {
        ...useLedgerActions(),
        onRowClick
    };
};
